import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { JwtService } from '../../../common/services/jwt.service';
@Component({
  selector: 'utilization-panel',
  templateUrl: './utilization.component.html',
  styleUrls: ['./utilization.component.css']
})
export class UtilizationComponent {
  @Input() header = '';
  @Input() collapsed = false;
  @Output() collapsedChange: EventEmitter<boolean>;
  @Input() visible = false;
  @Input() items = null;
  @Input() yearDataDisplayed;
  selectedId: string;

  tableauJWT: string;
  renderTableau = true;
  isMapCollapsed = true;
  showInnerHtmlUtilization: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private jwtService: JwtService,
  ) {
    this.collapsedChange = new EventEmitter<boolean>();
    this.selectedId = this.route.snapshot.params['id'];

    this.jwtService.getToken().subscribe(token => {
      this.tableauJWT = token;
    });
  }

  get tableauUtilizationURL(): string {
    //return 'https://us-west-2b.online.tableau.com/#/site/aha/views/ProfileTrendLines/TrendLines'
    return '#'
  }

  updateInnerHTMLTokenUtilization() {
    if (this.showInnerHtmlUtilization && this.tableauJWT) {
      const tableauContainer = document.getElementById('tableauContainerUtilization');
      if (tableauContainer) {
        tableauContainer.innerHTML = `
        `;
      }
    }
  }

  get tableuSelectedID(): string {
    // For utilization we don't need to send the 000 at the beg of the id
    return this.selectedId
  }

  onClick() {
    this.collapsedChange.emit(!this.collapsed);
  }

  toggleUtilizationMap() {
    this.isMapCollapsed = !this.isMapCollapsed;
    this.showInnerHtmlUtilization = !this.showInnerHtmlUtilization;
    if (this.showInnerHtmlUtilization) {
      //his.updateInnerHTMLTokenUtilization();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/profile/panels/utilization/utilization.component.ts